{
  "401": {
    "title": "Onvoldoende rechten",
    "description": "Sorry, u ({{email}}) heeft niet de juiste rechten om deze pagina te bekijken. Neem contact op met uw verkoopadviseur voor meer informatie.",
    "button": "Terug naar inlog pagina",
    "button2": "Uitloggen"
  },
  "404": {
    "title": "Pagina niet gevonden",
    "description": "Sorry, de pagina die je zoekt bestaat niet. Het kan zijn dat de pagina is verwijderd, de naam is gewijzigd of dat de pagina tijdelijk niet beschikbaar is.",
    "button": "Terug naar de homepagina"
  },
  "500": {
    "title": "Er is iets misgegaan",
    "description": "Er is iets misgegaan. Probeer het later opnieuw.",
    "button": "Terug naar de homepagina"
  },
  "Search": "Zoeken",
  "ClearSearch": "Zoekopdracht wissen",
  "Searchingfor": "Zoek in de prijslijst",
  "Logout": "Uitloggen",
  "profileMenu": "Profielmenu",
  "login": "Login",
  "SatellietOriginals": "Satelliet Originals",
  "Prijslijst": "Prijslijst",
  "seo": {
    "title": "Satelliet Prijslijst",
    "titleOriginals": "Satelliet Originals Prijslijst",
    "siteName": "Satelliet Meubelen",
    "siteNameOriginals": "Satelliet Originals",
    "description": "Online prijslijst van Satelliet Meubelen.",
    "descriptionOriginals": "Online prijslijst van Satelliet Originals."
  },
  "IfThisErrorPersists": "Als deze fout aanhoudt, neem dan contact op met solutions@satelliet.net.",
  "language": {
    "English": "English",
    "Dutch": "Nederlands"
  },
  "navbar": {
    "info": "Extra informatie",
    "brands": "Brands",
    "colorChart": "Kleurenoverzicht",
    "fermob": "Fermob",
    "Home": "Home",
    "SearchPrijslijst": "Doorzoek de Prijslijst",
    "Delivery": "Levering",
    "coatings": "Overcoaten",
    "fabrics": "Stoffen en leer",
    "prices": "Prijzen",
    "fabricChart": "Stoffentabel",
    "fabricsOverview": "Stoffenoverzicht",
    "outdoorStock": "Voorraad collectie outdoor stoffen",
    "USPs": "USP's"
  },
  "GA": {
    "body": "Deze website maakt gebruik van cookies om uw ervaring te verbeteren. Door op 'Accepteren' te klikken, ga je akkoord met het gebruik van deze cookies.",
    "accept": "Accepteren",
    "decline": "Weigeren"
  },
  "footer": {
    "pricingExclVAT": "Prijzen excl. BTW",
    "statements": "Voorwaarden",
    "salesConditions": "Verkoopvoorwaarden",
    "cookieStatement": "Cookie policy",
    "privacyStatement": "Privacy statement",
    "aboutSatelliet": "Over Satelliet",
    "aboutSatellietOriginals": "Over Satelliet Originals",
    "sustainability": "Duurzaamheid",
    "showrooms": "Vestigingen",
    "contact": "Contact",
    "salesConditionsUrl": "https://www.satelliet.net/verkoopvoorwaarden/",
    "cookieStatementurl": "https://www.satelliet.net/cookie-statement/",
    "privacyStatementUrl": "https://www.satelliet.net/privacy-statement/",
    "aboutSatellietUrl": "https://www.satelliet.net/over-satelliet/over-onze-organisatie/",
    "sustainabilityUrl": "https://www.satelliet.net/duurzaamheid/",
    "showroomsUrl": "https://www.satelliet.net/showrooms/",
    "contactUrl": "https://www.satelliet.net/service-contact/"
  },
  "Version": "Versie",
  "ascName": "Naam ↑",
  "descName": "Naam ↓",
  "descSalesCount": "Populariteit ↓",
  "descPageViews": "Paginaweergaven ↓",
  "ascPrice": "Prijs ↑",
  "descPrice": "Prijs ↓",
  "currencies": {
    "EUR": "Euro (€)",
    "USD": "VS Dollar ($)",
    "GBP": "Britse Pond (£)",
    "CHF": "Zwitserse Frank (CHF)",
    "NOK": "Noorse kroon (kr)"
  },
  "imageSearch": {
    "announcement": {
      "title": "Nieuw: zoeken met foto",
      "description": "Upload een foto van een stoel en ontdek vergelijkbare Satelliet-modellen.",
      "dismiss": "Begrepen"
    },
    "photo": "Foto",
    "title": "Zoeken met foto",
    "close": "Sluiten",
    "diagnosticsToggle": "Diagnostiek fotozoeken"
  }
}
